import * as React from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
// @ts-ignore
import { DateRange } from 'react-date-range';
import locale from 'date-fns/locale/fr';

export default (props: any) => <DateRange locale={locale} {...props} />;
